import { render, staticRenderFns } from "./DocumentIcon.vue?vue&type=template&id=5ff0b6fe&scoped=true&"
import script from "./DocumentIcon.vue?vue&type=script&lang=js&"
export * from "./DocumentIcon.vue?vue&type=script&lang=js&"
import style0 from "./DocumentIcon.vue?vue&type=style&index=0&id=5ff0b6fe&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ff0b6fe",
  null
  
)

export default component.exports